import type { ValidationErrors } from '../../../../../utils/validation';
import type { IAfwijkingen } from '../../TCCr/v1/CardioAfwijkingen';
import { InputRadioGroup } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../../../../elements/forms/HorizontalFormGroup';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { AddEditAfwijkingen, getEmptyAfwijkingen } from '../../TCCr/v1/CardioAfwijkingen';

export interface ICustomControlData extends IAfwijkingen {
    conclusie: string | null;
}

interface ITcorV1DiagnosticReportAddEditCustomControlFieldsProps {
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (values: Partial<ICustomControlData>) => Promise<void>;
    validateOneCustomControl: (name: string) => Promise<void>;
}

export function TcorV1DiagnosticReportAddEditCustomControlFields(
    props: ITcorV1DiagnosticReportAddEditCustomControlFieldsProps
) {
    const handleChangeCustomControl = async (value: Partial<ICustomControlData>) => {
        await props.handleChangeCustomControl(value);
    };

    const validateOneCustomControl = async (name: keyof ICustomControlData) => {
        await props.validateOneCustomControl(name);
    };

    return (
        <>
            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.conclusie')}>
                <FormLabel isRequired>Conclusie</FormLabel>
                <InputContainer>
                    <InputRadioGroup
                        automation="conclusie"
                        error={props.errors.get('customControlData.conclusie')}
                        name="conclusie"
                        onChange={async (value) =>
                            await handleChangeCustomControl({
                                conclusie: value,
                                afwijking_in:
                                    value !== 'Afwijkend'
                                        ? getEmptyAfwijkingen().afwijking_in
                                        : props.customControlData.afwijking_in,
                                afwijking_details:
                                    value !== 'Afwijkend'
                                        ? getEmptyAfwijkingen().afwijking_details
                                        : props.customControlData.afwijking_details,
                            })
                        }
                        onDoValidate={async () => await validateOneCustomControl('conclusie')}
                        options={['Normaal', 'Afwijkend', 'Niet te beoordelen']}
                        value={props.customControlData.conclusie}
                    />
                </InputContainer>
            </HorizontalFormGroup>
            {props.customControlData.conclusie && props.customControlData.conclusie === 'Afwijkend' && (
                <AddEditAfwijkingen
                    afwijkingen={props.customControlData}
                    errors={props.errors}
                    onChange={async (value) => await handleChangeCustomControl(value)}
                    onDoValidate={async (name, category, disorder) => {
                        const afwijkingenName = name + (disorder ? `.${category}.${disorder}` : `.${category}`);
                        await props.validateOneCustomControl(afwijkingenName);
                    }}
                />
            )}
        </>
    );
}

export function tcorV1DiagnosticReportInitializeCustomControlData() {
    return {
        ...getEmptyAfwijkingen(),
        conclusie: null,
    };
}
